module.exports = __webpack_public_path__ + "img/MyOffers.80d32d48.png";